import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './domain/auth/login/login.component';
import { LoginFailedComponent } from './domain/auth/login-failed/login-failed.component';
import { MsalGuard } from "@azure/msal-angular";

const routes: Routes = [
    {
        path: 'login',
        component: LoginComponent,
    },
    {
        path: 'login-failed',
        component: LoginFailedComponent
    },
    {
        path: 'redirect',
        redirectTo: 'home'
    },
    {
        path: '**',
        canActivate: [MsalGuard],
        loadComponent: () =>
            import('./domain/docs-redirect/docs-redirect.component')
            .then(m => m.DocsRedirectComponent)
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
